import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  padding: 2rem;
  font-family: 'Montserrat', sans-serif;
  @media (max-width : 768px){
   padding : 0;
  }
`;

export const FormWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const FormHeader = styled.div`
  background: #5BBCEA;
  color: white;
  padding: 2rem;
  text-align: center;
  
  h1 {
    margin: 0;
    font-size: 2rem;
    font-weight: 600;
    letter-spacing: -0.5px;
  }
  
  p {
    margin: 0.5rem 0 0 0;
    opacity: 0.9;
    font-size: 1rem;
  }
`;

export const FormContent = styled.div`
  padding: 2rem;
`;

export const FormGroup = styled.div`
 display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 1.5rem;
 
`;

export const Label = styled.label`
  color: #2d3748;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Montserrat', sans-serif;
  
  .required {
    color: #e53e3e;
    margin-left: 4px;
  }
`;

export const Input = styled.input`
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  font-family: 'Montserrat', sans-serif;
  transition: all 0.3s ease;
  background: #f8fafc;

  &:focus {
    outline: none;
    border-color: #5BBCEA;
    background: white;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    transform: translateY(-1px);
  }

  &:hover {
    border-color: #cbd5e0;
  }
`;

export const Select = styled.select`
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  font-family: 'Montserrat', sans-serif;
  background: #f8fafc;
  transition: all 0.3s ease;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #5BBCEA;
    background: white;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    transform: translateY(-1px);
  }

  &:hover {
    border-color: #cbd5e0;
  }
`;

export const TextArea = styled.textarea`
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  font-family: 'Montserrat', sans-serif;
  min-height: 100px;
  resize: vertical;
  background: #f8fafc;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #5BBCEA;
    background: white;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    transform: translateY(-1px);
  }

  &:hover {
    border-color: #cbd5e0;
  }
`;

export const RadioGroup = styled.div`
 display: flex;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const RadioOption = styled.div`
   display: flex;
  align-items: center;
  justify-content : center;
  gap: 8px;
  padding: 8px 12px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f8fafc;
  min-width: 120px;
  @media (max-width : 768px){
   min-width : 160px
  }
  &:hover {
    border-color: #cbd5e0;
    transform: translateY(-1px);
  }

  &.selected {
    border-color: #5BBCEA;
    background: rgba(102, 126, 234, 0.1);
    color: #5BBCEA;
    font-weight: 500;
  }

  input[type="radio"] {
    margin: 0;
    accent-color: #5BBCEA;
    pointer-events: none; /* Désactive les événements sur l'input pour éviter les conflits */
  }

  label {
    margin: 0;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    pointer-events: none; /* Désactive les événements sur le label */
  }
`;

export const CheckboxGroup = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: center;
`;

export const CheckboxOption = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f8fafc;

  &:hover {
    border-color: #cbd5e0;
    transform: translateY(-1px);
  }

  &.selected {
    border-color: #5BBCEA;
    background: rgba(102, 126, 234, 0.1);
    color: #5BBCEA;
  }

  input[type="checkbox"] {
    margin: 0;
    accent-color: #5BBCEA;
  }

  label {
    margin: 0;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
  }
`;

export const Button = styled.button`
  padding: 14px 28px;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  ${props => {
    switch(props.variant) {
      case 'primary':
        return `
          background: #5BBCEA;
          color: white;
          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
          }
          &:active {
            transform: translateY(0);
          }
        `;
      case 'secondary':
        return `
          background: #f8fafc;
          color: #4a5568;
          border: 2px solid #e2e8f0;
          &:hover {
            background: #edf2f7;
            border-color: #cbd5e0;
            transform: translateY(-1px);
          }
        `;
      case 'danger':
        return `
          background: linear-gradient(135deg, #fc8181 0%, #e53e3e 100%);
          color: white;
          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(229, 62, 62, 0.4);
          }
        `;
      default:
        return `
          background: #718096;
          color: white;
          &:hover {
            background: #4a5568;
            transform: translateY(-1px);
          }
        `;
    }
  }}
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 2rem;
  margin-bottom : 1rem;
  padding-top: 2rem;
  border-top: 1px solid #e2e8f0;
`;

export const VehicleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
`;

export const VehicleCard = styled.div`
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f8fafc;
  position: relative;

  &:hover {
    border-color: #cbd5e0;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  &.selected {
    border-color: #5BBCEA;
    background: rgba(102, 126, 234, 0.1);
    color: #5BBCEA;
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #f1f5f9;
    
    &:hover {
      transform: none;
      box-shadow: none;
      border-color: #e2e8f0;
    }
  }

  img {
    width: 60px;
    height: 60px;
    object-fit: contain;
    margin-bottom: 0.5rem;
  }

  .vehicle-name {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 0.25rem;
  }

  .vehicle-capacity {
    font-size: 12px;
    color: #718096;
  }

  input[type="radio"] {
    position: absolute;
    opacity: 0;
  }
`;

export const SectionTitle = styled.h3`
  color: #2d3748;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 2rem 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e2e8f0;
`;

export const FlexRow = styled.div`
  display: flex;
  gap: 1rem;
  align-items: ${props => props.align || 'flex-start'};
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: ${props => props.flex || '1'};
  min-width: ${props => props.minWidth || 'auto'};
`;

export const Tooltip = styled.div`
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  background: #2d3748;
  color: white;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: #2d3748;
  }
`;